import * as React from 'react';

var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgPmPaypalVenmo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.889 6.25H32.11c.912 0 1.639.716 1.639 1.583v18.334c0 .867-.727 1.583-1.639 1.583H1.89c-.912 0-1.639-.716-1.639-1.583V7.833c0-.867.727-1.583 1.639-1.583z",
    fill: "#F5F5F5",
    stroke: "#233976",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.024 14.483c1.574 0 2.85-1.228 2.85-2.742 0-.274-.04-.538-.119-.788.788.11 1.462.556 1.86 1.182.244.383.384.833.384 1.315 0 1.393-1.174 2.522-2.623 2.522h-1.033a.633.633 0 00-.63.514l-.347 2a.633.633 0 01-.63.514H7.283c-.393 0-.693-.337-.632-.71l.091-.518.481-2.776a.633.633 0 01.63-.513h1.17z",
    fill: "#009DDC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.024 14.483c1.575 0 2.851-1.227 2.851-2.742a2.643 2.643 0 00-.417-1.428A2.875 2.875 0 009.024 9H5.865a.632.632 0 00-.631.52l-1.226 7.543c-.06.373.239.71.631.71h2.105l.48-2.776a.633.633 0 01.631-.514h1.17z",
    fill: "#1D3586"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.025 14.483c1.574 0 2.85-1.228 2.85-2.742 0-.274-.04-.538-.119-.788H8.53a.714.714 0 00-.704.592l-.6 3.45a.633.633 0 01.63-.512h1.169z",
    fill: "#211D70"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.063 24.755l-1.06-7.938a.283.283 0 01.252-.318l2.269-.226a.283.283 0 01.308.24l.71 4.955c.036.254.357.327.486.105 1.087-1.88 1.191-3.785 1.074-4.767a.3.3 0 01.234-.333l2.34-.467a.272.272 0 01.304.153c1.355 3.084-1.258 7.043-2.84 8.753a.275.275 0 01-.204.088h-3.592a.283.283 0 01-.28-.245z",
    fill: "#008CFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9 25L25 9",
    stroke: "#233976",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })));
}

export { SvgPmPaypalVenmo as ReactComponent };
